import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IDrawerState {
  isOpen: boolean;
  name: string;
  data: any;
  title?: string;
  isIndirect?: boolean;
  variant?: "light" | "dark";
  width?: string;
}

const initialState: IDrawerState = {
  isOpen: false,
  name: "",
  data: null,
  title: "",
  isIndirect: false,
  variant: "dark",
  width: "sm:w-80",
};

const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    opened: (
      state,
      action: PayloadAction<{
        name: string;
        data?: any;
        title?: string;
        isIndirect?: boolean;
        variant?: "light" | "dark";
        width?: string;
      }>
    ) => {
      state.isOpen = true;
      state.name = action.payload.name;
      state.data = action.payload.data !== undefined ? action.payload.data : null;
      state.title = action.payload.title || "";
      state.isIndirect = action.payload.isIndirect || false;
      state.variant = action.payload.variant || "dark";
      state.width = action.payload.width || "sm:w-80";
    },
    closed: (state) => {
      state.isOpen = false;
      state.name = "";
      state.data = null;
      state.title = "";
      state.isIndirect = false;
      state.variant = "dark";
      state.width = "sm:w-80";
    },
  },
});

export const { opened, closed } = drawerSlice.actions;
export default drawerSlice.reducer;
